// extracted by mini-css-extract-plugin
export default {"layout-conatiner":"SalesRouteLayout_layout-conatiner__u+GiM"};